import { createSelector } from 'reselect'
import viewTypes from 'helpers/enums/viewTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import getQuickLaunchData from 'redux/selectors/quick_launch/quick_launch_selector'
import shouldHideStoreSelector from 'redux/selectors/user/user_store_access_selector'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import viewsWithoutIcons from 'helpers/viewsWithoutIcons'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.MAIN_TOPBAR_TOOLTIPS,
	featureFlagsTypes.QUICK_LAUNCH_FIELDTRIP,
	featureFlagsTypes.QUICK_LAUNCH_DRAWIT,
	featureFlagsTypes.QUICK_LAUNCH_OEQ,
	featureFlagsTypes.QUICK_LAUNCH_TIMER,
	featureFlagsTypes.VIDEO_LESSON_TYPE,
	featureFlagsTypes.PAYWALLS_PROJECT,
	featureFlagsTypes.NAV_TOPBAR,
	featureFlagsTypes.CREATE_MENU,
])

const getUserImage = state => state.user.data.image
const getCurrentView = state => state.ui.currentView
const userExtraSelector = state => state.user.extra ? state.user.extra : {}
const getFullDataLoaded = state => state.user.fullDataLoaded

const getTopbarData = createSelector(
	[getUserImage, getCurrentView, featureFlagsSelector, userExtraSelector, shouldHideStoreSelector, getQuickLaunchData, getFullDataLoaded],
	(userImage, currentView, featureFlags, userExtra, shouldHideStore, quickLaunchData, fullDataLoaded) => {
		const canShowItems = !viewsWithoutIcons.includes(currentView)

		const viewsWithFolderDropdownOption = [viewTypes.LIBRARY]
		const shouldShowFolderDropdownOption = viewsWithFolderDropdownOption.includes(currentView)

		const isPremiumUser = !!userExtra.hasPremiumAyce
		const isExtraDataLoaded = !!userExtra._isLoaded

		const tooltips = userExtra.tooltips ? userExtra.tooltips : {}
		const shouldShowTooltipGSCreateLesson = !!tooltips.tooltipGSCreateLesson

		const shouldShowCartButton = !featureFlags[featureFlagsTypes.PAYWALLS_PROJECT]
			&& canShowItems
			&& fullDataLoaded
			&& isExtraDataLoaded
			&& !shouldHideStore
			&& !isPremiumUser

		const shouldShowAddButton = canShowItems

		return {
			userImage,
			shouldShowFolderDropdownOption,
			shouldShowTooltipGSCreateLesson,
			shouldShowCartButton,
			shouldShowAddButton,
			quickLaunchData,
			shouldShowTooltips: featureFlags[featureFlagsTypes.MAIN_TOPBAR_TOOLTIPS],
			canCreateInteractiveVideo:
				featureFlags[featureFlagsTypes.VIDEO_LESSON_TYPE],
			shouldUpdateNavTopbar: featureFlags[featureFlagsTypes.NAV_TOPBAR],
			shouldUpdateCreateLesson: featureFlags[featureFlagsTypes.CREATE_MENU],
		}
	}
)

export default getTopbarData
